import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { CONSTANT, DataService } from "../../../../shared/session/index";
import { SessionInfo } from "../../../../shared/session/SessionInfo";
import { Iempresa } from './empresa.model';


@Injectable({
    providedIn: 'root',
})
export class EmpresaService {
    constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

    private insertarEmpresaUrl: string = 'empresa/Insertar';
    private actualizarEmpresaUrl: string = 'empresa/Actualizar';
    private obtenerEmpresaUrl: string = 'empresa/obtener';
    private listarPorEmpresaUrl: string = 'empresa/ListarPor';
    private listarEmpresaUrl: string = 'empresa/listar';
    private listarEmpresaPorUsarioUrl: string = 'empresa/listarPorUsuario';

    listarEmpresa(filtro: string, pageIndex: number, pageSize: number): any {
        let parameters = new HttpParams();
        parameters = parameters.append("pFiltro", String(filtro));
        parameters = parameters.append("pageIndex", String(pageIndex));
        parameters = parameters.append("pageSize", String(pageSize));
        parameters = parameters.append("empresaID", (CONSTANT.kMicrobankId == this.sessionInfo.getEmpresaID()) ? null : String(this.sessionInfo.getEmpresaID()));
        this.dataService.set(this.listarPorEmpresaUrl);
        return this.dataService.execGetJson(parameters);
    }

    obtenerEmpresa(empresaID: number): any {
        let parameters = new HttpParams();
        parameters = parameters.append("pKey", String(empresaID));
        this.dataService.set(this.obtenerEmpresaUrl);
        return this.dataService.execGetJson(parameters);
    }

    listEmpresa(): any {
        this.dataService.set(this.listarEmpresaUrl);
        return this.dataService.execGetJson();
    }

    insertarEmpresa(empresa: Iempresa): any {
        let parameters: string;
        parameters = JSON.stringify({
            Name: empresa.Name,
            Direccion: empresa.Direccion,
            RUC: empresa.RUC,
            RazonSocial: empresa.RazonSocial,
            Agent: empresa.Agent,
            Dni: empresa.Dni,
            status: 1,
            UserCreation: this.sessionInfo.getCodUsuario(),
            nombreCorto: empresa.nombreCorto,
        });

        this.dataService.set(this.insertarEmpresaUrl);
        return this.dataService.execPostJson(parameters);
    }

    listarEmpresaPorUsuario(userName: string, rolID: number): any {
        let parameters = new HttpParams();
        parameters = parameters.append("userName", String(userName));
        parameters = parameters.append("rolID", String(rolID));
        this.dataService.set(this.listarEmpresaPorUsarioUrl);
        return this.dataService.execGetJson(parameters);
    }

    actualizarEmpresa(empresa: Iempresa): any {
        let parameters: string;
        parameters = JSON.stringify({
            ID: empresa.ID,
            Name: empresa.Name,
            Direccion: empresa.Direccion,
            RUC: empresa.RUC,
            RazonSocial: empresa.RazonSocial,
            Agent: empresa.Agent,
            Dni: empresa.Dni,
            status: empresa.status,
            UserLastUpdate: this.sessionInfo.getCodUsuario(),
            imagenFirma: empresa.imagenFirma,
            nombreCorto: empresa.nombreCorto,
        });
        this.dataService.set(this.actualizarEmpresaUrl);
        return this.dataService.execPostJson(parameters);
    }
}
